module.exports = __webpack_public_path__ + "7dbf6120f447e4f4485fbe7489d39643.svg";